export default "__VITE_ASSET__CjRjaOIm__"